import React, { Fragment } from 'react';
import GenericButton from '../../../common/GenericButton';
import { RLD_SELECTION, INCORRECT_SELECTION_MESSAGE } from '../../constants';
import { ModalContainer, ButtonWrapper } from '../../styledComponents';
import PropTypes from 'prop-types';

const RldOnlyModal = ({ onContinueClicked }) => {
  const continueClicked = () => {
    onContinueClicked(false);
  };
  return (
    <Fragment>
      <ModalContainer>
        {INCORRECT_SELECTION_MESSAGE}
        {RLD_SELECTION}
        <ButtonWrapper>
          <GenericButton name="Continue" onBtnClick={continueClicked} />
        </ButtonWrapper>
      </ModalContainer>
    </Fragment>
  );
};
RldOnlyModal.propTypes = {
  onContinueClicked: PropTypes.func,
};
export default RldOnlyModal;
